import { ifyouApi, kevinAuthAPI, STORY } from 'apis/config';
/**
 * * 리소스 - 라이브 오브젝트 (미니컷 라이브)
 */

export const liveObjApi = {
  read: (projectId, lang) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-list`, {
        lang: lang,
      })
      .then((res) => res.data.map((v, i) => ({ ...v, key: i }))),
  // 하위 테이블
  detailList: (projectId, liveObjId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-detail-list`, {
        live_object_id: liveObjId,
      })
      .then((res) => res.data),
  detail: (projectId, liveObjId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-detail`, {
        minicut_id: String(liveObjId),
        minicut_type: 'live2d',
      })
      .then((res) => res.data),
  register: ({ projectId, title }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-register`, {
        live_object_name: title,
      })
      .then((res) => res.data),
  update: ({ projectId, minicutId, detailData, langList }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-update`, {
        live_object_id: minicutId,
        live_object_name: detailData.live_object_name,
        offset_x: detailData.offset_x,
        offset_y: detailData.offset_y,
        game_scale: detailData.game_scale,
        is_public: detailData.is_public,
        thumbnail_id: detailData.thumbnail_id,
        appear_episode: detailData.appear_episode,
        speaker: detailData.speaker,
        langList: langList,
      })
      .then((res) => res.data),

  zipUpload: ({ projectId, formData }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  delete: ({ projectId, minicutId }) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-object-delete`, {
        live_object_id: minicutId,
      })
      .then((res) => res.data),
  // NEW API
  liveObjectList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/live/${projectId}/live_object`)
      .then((res) => res.data),
  liveObjectCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/live/${projectId}/live_object`, data)
      .then((res) => res.data),
  liveObjectZip: (projectId, id, data) =>
    kevinAuthAPI
      .post(`/resource-manager/live/${projectId}/live_object/${id}`, data)
      .then((res) => res.data),
  liveObjectDelete: (projectId, id) =>
    kevinAuthAPI
      .delete(`/resource-manager/live/${projectId}/live_object/${id}`)
      .then((res) => res.data),
  liveObjectUpdate: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/resource-manager/live/${projectId}/live_object/${id}`, data)
      .then((res) => res.data),
  liveObjectThumnailUpdate: (projectId, id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .post(`/resource-manager/live-thumbnail/${projectId}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data);
  },
};
